var map = {
	"./account-icon.png": 8473,
	"./article-icon.png": 6120,
	"./bettercom-logo.png": 4299,
	"./caja-icon.png": 1413,
	"./cart-icon.png": 134,
	"./galileo-logo.png": 2193,
	"./galileoinsight-logo.png": 2293,
	"./home-icon.png": 1395,
	"./lock.png": 7641,
	"./money-icon.png": 1382,
	"./placeholder-logo.png": 9953,
	"./search-icon.png": 4520,
	"./stock-icon.png": 484,
	"./user.png": 4441,
	"./visibility.png": 5760,
	"./visibility_off.png": 4606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;